import React from 'react';
import { useHistory } from 'react-router-dom';

// STYLES
import * as S from '../../Configurations/CreateClub/LandingPage/LandingPageList/styles';
import { Box } from '@mui/material';
import PatternButton from '../Buttons/PatternButton';
import searchIcon from 'styles/assets/SearchUser/search.svg';

export const SearchBarWithButton = ({
  buttonLabel,
  buttonDisabled,
  placeHolderSearch,
  searchDisabled,
  setValueSearch,
  urlExtension,
  userPoints,
  valueSearch,
}) => {
  const history = useHistory();

  const handleButtonClick = () => {
    history.push({
      pathname: `${history.location.pathname}/${urlExtension}`,
      state: { userPoints },
    });
  };
  return (
    <>
      {!searchDisabled && (
        <S.BoxSearch>
          <S.InputBox>
            <S.Input
              placeholder={placeHolderSearch}
              value={valueSearch}
              onChange={(e) => setValueSearch(e.target.value)}
            />
            <S.SearchIconButton>
              <img src={searchIcon} alt="" />
            </S.SearchIconButton>
          </S.InputBox>
        </S.BoxSearch>
      )}

      <Box display={'flex'} justifyContent={'right'} width={'100%'}>
        <PatternButton disabled={buttonDisabled} width={'200px'} onClick={handleButtonClick}>
          {buttonLabel}
        </PatternButton>
      </Box>
    </>
  );
};
